import { countryShortCodes } from 'utilities/constants';
import Select from 'react-select';

function BoardsList({ value, handleChange }) {
  const __boards = Object.values(boards).reduce((a, x) => {
    return a.concat(x);
  }, []);

  return (
    <>
      <label>Exam board</label>
      <Select
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
        }}
        isClearable={false}
        isSearchable={false}
        className="basic-single"
        classNamePrefix="select"
        name="mcqOptionsDq"
        options={__boards}
        value={__boards.find?.((x) => x.value === value)}
        onChange={(args) => {
          const examBoard = args.value;
          handleChange({ examBoard });
        }}
      />
      {/* <select
        value={value}
        onChange={(event) => {
          const examBoard = event.target.value;
          handleChange({ examBoard }, event);
        }}
      >
        <option value="">Select</option>
        {__boards.map((b) => (
          <option value={b.value}>{b.label}</option>
        ))}
      </select> */}
    </>
  );
}

BoardsList.defaultProps = {
  handleChange: () => {},
};

const boards = {
  [countryShortCodes.in]: [
    {
      label: 'ISC',
      value: 'isc',
    },
    {
      label: 'CISCE',
      value: 'cisce',
    },
    {
      label: 'CBSE',
      value: 'cbse',
    },
    {
      label: 'KBPE',
      value: 'kbpe',
    },
    {
      label: 'Tamil Nadu State Board',
      value: 'tamil_nadu_state_board',
    },
  ],
  [countryShortCodes.uk]: [
    {
      label: 'AQA',
      value: 'aqa',
    },
    {
      label: 'Edexcel',
      value: 'edexcel',
    },
    {
      label: 'OCR',
      value: 'ocr',
    },
  ],
};

export { boards as AppBoards };
export default BoardsList;
